// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"e443b330","534":"ef7a62c9"}[chunkId] + ".chunk.js";
};